const breakpoints = {
  sm: '30em',
  md: '48em',
  lg: '62em',
  xl: '80em',
  '2xl': '96em',
} as const

export type Breakpoints = keyof typeof breakpoints

export default breakpoints
